<template>
  <div class="bg-rad">
    <div class="rounded bg-white">
        <div class="row">
            <div class="col-md-3 border-right">
                <div class="d-flex flex-column align-items-center text-center">
                    <div v-if="!fileurl">
                        <img
                            v-if="!formPass.avatar"
                            class="mt-2 p-img"
                            src="../../assets/images/usericone.png"
                            >
                        <img
                            v-if="formPass.avatar"
                            class="mt-2 p-img"
                            :src="formPass.avatar"
                            >
                    </div>
                    <div v-else>
                        <img
                            class="mt-2 p-img"
                            :src="fileurl"
                            >
                    </div>
                    <span class="font-weight-bold">{{formPass.lastname + ' ' + formPass.firstname}}</span>
                    <span class="text-black-50">{{formPass.email}}</span>
                    <div>
                        <label
                            class="custom-file-upload btn btn-primary">
                            <input
                                type="file"
                                name="fields[assetsFieldHandle][]"
                                @change="onChange"
                                ref="file"
                                accept=".jpg,.jpeg,.png"
                            />
                            {{$t("message.choose_image")}}
                        </label>
                    </div>
                </div>
            </div>
            <div class="col-md-9 border-right">
                <div class="">
                    <div class="d-flex justify-content-between align-items-center mb-3">
                        <h4 class="text-right text-primary">{{$t("message.personal_setting")}}</h4>
                    </div>
                    <div class="row mt-2">
                        <div class="col-md-6">
                            <label class="labels">{{$t("message.last_name") + ' (' +$t("message.in_khmer") + ')'}}</label>
                            <input type="text" class="form-control" 
                                :placeholder="$t('message.last_name')" 
                                v-model="formPass.lastname"
                                :class="{ 'is-invalid': v$.formPass.lastname.$error }">
                        </div>
                        <div class="col-md-6">
                            <label class="labels">{{$t("message.first_name") + ' (' +$t("message.in_khmer") + ')'}}</label>
                            <input type="text" class="form-control" 
                                    :placeholder="$t('message.first_name')"
                                    v-model="formPass.firstname"
                                    :class="{ 'is-invalid': v$.formPass.firstname.$error }">
                        </div>
                    </div>

                    <div class="row mt-2">
                        <div class="col-md-6">
                            <label class="labels">{{$t("message.last_name") + ' (' +$t("message.in_latin") + ')'}}</label>
                            <input type="text" class="form-control" 
                                :placeholder="$t('message.last_name')" 
                                v-model="formPass.lastname_en"
                                :class="{ 'is-invalid': v$.formPass.lastname_en.$error }">
                        </div>
                        <div class="col-md-6">
                            <label class="labels">{{$t("message.first_name") + ' (' +$t("message.in_latin") + ')'}}</label>
                            <input type="text" class="form-control" 
                                    :placeholder="$t('message.first_name')"
                                    v-model="formPass.firstname_en"
                                    :class="{ 'is-invalid': v$.formPass.firstname_en.$error }">
                        </div>
                    </div>

                    <div class="row mt-2">
                        <div class="col-md-6">
                            <label class="labels">{{$t("message.gender")}}</label>
                            <select
                                class="form-select"
                                v-model="formPass.gender"
                                :placeholder="$t('message.gender')"
                                :title="$t('message.gender')"
                                :class="{ 'is-invalid': v$.formPass.gender.$error }"
                            >
                                <option selected>Choose...</option>
                                <option value="1">ប្រុស (Male)</option>
                                <option value="2">ស្រី (Female)</option>
                            </select>
                        </div>
                        <div class="col-md-6">
                            <label class="labels">{{$t("message.dob")}}</label>
                            <input type="text" 
                                    class="form-control" 
                                    v-maska="'##/##/####'"
                                    :placeholder="$t('message.dob')"
                                    v-model="formPass.dob"
                                    :class="{ 'is-invalid': v$.formPass.dob.$error }">
                        </div>
                    </div>

                    <div class="row mt-2">
                        <div class="col-md-6">
                            <label class="labels">{{$t("message.nationality")}}</label>
                            <select
                                id="nationality"
                                v-model="formPass.nationality"
                                class="form-select"
                                :class="{ 'is-invalid': v$.formPass.nationality.$error }"
                                aria-label="Default select example"
                                searchable="Search here.."
                            >
                                <option selected>Open this select menu</option>
                                <option
                                    v-for="item in getCountryCode"
                                    :key="item.id"
                                    :value="item.id"
                                    >{{ item.name }}</option
                                >
                            </select>
                        </div>
                        <div class="col-md-6">
                            <label class="labels">{{$t("message.nationality_idcard_or_passport")}}</label>
                            <input type="text" class="form-control" 
                                    :placeholder="$t('message.nationality_idcard_or_passport')"
                                    v-model="formPass.national_id_card"
                                    :class="{ 'is-invalid': v$.formPass.national_id_card.$error }">
                        </div>
                    </div>

                    <div class="row mt-2">
                        <div class="col-md-6">
                            <label class="labels">{{$t("message.phone")}}</label>
                            <input type="text" class="form-control" 
                                :placeholder="$t('message.phone')" 
                                v-model="formPass.phone">
                        </div>
                        <div class="col-md-6">
                            <label class="labels">{{$t("message.email")}}</label>
                            <input type="text" class="form-control" 
                                    :placeholder="$t('message.email')"
                                    v-model="formPass.email">
                        </div>
                    </div>

                    <div class="d-flex justify-content-between align-items-center mt-3">
                        <h5 class="text-right text-bold">{{$t("message.address")}}</h5>
                    </div>
                    <div class="row mt-1">
                        <div class="col-md-4 mb-2">
                            <label class="labels">{{$t("message.house_number")}}</label>
                            <input type="text" class="form-control" 
                                :placeholder="$t('message.house_number')" 
                                v-model="formPass.house_number">
                        </div>
                        <div class="col-md-4 mb-2">
                            <label class="labels">{{$t("message.street")}}</label>
                            <input type="text" class="form-control" 
                                    :placeholder="$t('message.street')"
                                    v-model="formPass.street">
                        </div>
                        <div class="col-md-4 mb-2">
                            <label class="labels">{{$t("message.village")}}</label>
                            <input type="text" class="form-control" 
                                :placeholder="$t('message.village')" 
                                v-model="formPass.village">
                        </div>
                        <div class="col-md-4 mb-2">
                            <label class="labels">{{$t("message.commune")}}</label>
                            <input type="text" class="form-control" 
                                    :placeholder="$t('message.commune')"
                                    v-model="formPass.commune">
                        </div>
                        <div class="col-md-4 mb-2">
                            <label class="labels">{{$t("message.district")}}</label>
                            <input type="text" class="form-control" 
                                :placeholder="$t('message.district')" 
                                v-model="formPass.district">
                        </div>
                        <div class="col-md-4 mb-2">
                            <label class="labels">{{$t("message.city_province")}}</label>
                            <input type="text" class="form-control" 
                                    :placeholder="$t('message.city_province')"
                                    v-model="formPass.city_province">
                        </div>
                    </div>

                    <div class="d-flex justify-content-between align-items-center mt-3">
                        <h5 class="text-right text-bold">{{$t("message.contact_person")}}</h5>
                    </div>
                     <div class="row mt-1">
                        <div class="col-md-3 mb-2">
                            <label class="labels">{{$t("message.name")}}</label>
                            <input type="text" class="form-control" 
                                :placeholder="$t('message.phone')" 
                                v-model="formPass.contact_persons.name">
                        </div>
                        <div class="col-md-3 mb-2">
                            <label class="labels">{{$t("message.gender")}}</label>
                            <select
                                class="form-select"
                                v-model="formPass.contact_persons.gender"
                                :placeholder="$t('message.gender')"
                                :title="$t('message.gender')"
                            >
                                <option selected>Choose...</option>
                                <option value="1">ប្រុស (Male)</option>
                                <option value="2">ស្រី (Female)</option>
                            </select>
                        </div>
                        <div class="col-md-3 mb-2">
                            <label class="labels">{{$t("message.phone")}}</label>
                            <input type="text" class="form-control" 
                                :placeholder="$t('message.phone')" 
                                v-model="formPass.contact_persons.phone">
                        </div>
                        <div class="col-md-3 mb-2">
                            <label class="labels">{{$t("message.email")}}</label>
                            <input type="text" class="form-control" 
                                    :placeholder="$t('message.email')"
                                    v-model="formPass.contact_persons.email">
                        </div>
                    </div>
                    
                    <div class="mt-5 text-end">
                    
                        <router-link class="btn btn-dark profile-button me-2" :to="{name:'myMember'}">
                            <i class="fas fa-arrow-left"></i> {{$t("message.back")}}
                        </router-link>
                        <button class="btn btn-primary profile-button" 
                            @click="actionUpdateInfo"
                            type="button"> {{$t("message.save")}} 
                            <i class="fas fa-save"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>
<script>
    import useVuelidate from "@vuelidate/core";
    import { required, email } from "@vuelidate/validators";
    import axios from "@/axios";
    import { mapGetters } from "vuex";
    export default {
        setup() {
            return {
                v$: useVuelidate()
            };
        },
        data() {
            return {
                filelist: "",
                fileurl: "",
                formPass: {
                    lastname:"",
                    firstname:"",
                    firstname_en:"",
                    lastname_en:"",
                    gender:"",
                    dob:"",
                    phone:"",
                    email:"",
                    national_id_card:"",
                    nationality:"",
                    house_number:"",
                    street:"",
                    village:"",
                    commune:"",
                    district:"",
                    city_province:"",
                    contact_persons: {}
                }
            };
        },
        validations() {
            return {
                formPass: {
                    lastname: { required, $autoDirty: true },
                    firstname: { required, $autoDirty: true },
                    firstname_en: { required, $autoDirty: true },
                    lastname_en: { required, $autoDirty: true },
                    gender: { required, $autoDirty: true },
                    dob: { required, $autoDirty: true },
                    phone: { required, $autoDirty: true },
                    email: { required,email, $autoDirty: true },
                    national_id_card: { required, $autoDirty: true },
                    nationality: { required, $autoDirty: true },
                }
            }
        },
        methods: {
            showLoader() {
                return this.$loading.show({
                // Optional parameters
                container: this.$refs.formContainer,
                color: "#01B201",
                canCancel: true,
                onCancel: this.onCancelLoader
                });
            },
            async loadMemerDetail(){
                const respone = await axios.get(`get-members-detail/${this.$route.params.memberId}`,{
                    headers: {
                        Authorization: `Bearer ${this.$store.getters.getAuthToken}`
                    }
                });
                this.formPass = respone.data.data;
            },
            actionUpdateInfo(){
                this.v$.$validate(); // checks all inputs
                if (!this.v$.$error) {
                    this.$swal
                        .fire({
                            title: this.$t("message.do_you_want_to_save"),
                            showCancelButton: true,
                            confirmButtonText: this.$t("message.yes"),
                            cancelButtonText: this.$t("message.cancel")
                        })
                        .then(async (result) => {
                            if (result.isConfirmed) {
                                let loader = this.showLoader();
                                try {
                                    const respone = await axios.put(`update-member/${this.$route.params.memberId}`
                                    , this.formPass, {
                                        headers: {
                                            Authorization: `Bearer ${this.$store.getters.getAuthToken}` 
                                        }
                                    });
                                    if (respone.status == 200) {
                                        this.$toast.open({
                                            message: this.$t("message.save_successfully"),
                                            type: "success",
                                            duration: 5000,
                                            dismissible: true,
                                            position: "top-right"
                                        });
                                    }
                                } catch (error) {
                                    this.$toast.open({
                                        message: error.response.data.message,
                                        type: "error",
                                        duration: 5000,
                                        dismissible: true,
                                        position: "top-right"
                                    });
                                }
                                loader.hide();
                            }
                        });
                }
            },
            async onChange() {
                this.filelist = this.$refs.file.files;
                const file = this.filelist[0];
                this.fileurl = URL.createObjectURL(file);
                let photoFormData = new FormData();
                photoFormData.append("file", this.filelist[0]);
                photoFormData.append("object_type", "photo");
                this.uploadPhoto(photoFormData,this.$route.params.memberId);  
            },
            async uploadPhoto(photoFormData,id){
                photoFormData.append("object_id", id);
                // eslint-disable-next-line
                const respone = await axios.post("media-file", photoFormData, {
                    headers: {
                    Authorization: "Bearer " + this.$store.getters.getAuthToken
                    }
                });
            },
        },
        computed: {
            ...mapGetters([
                'getMemberById'
                ,'getCountryCode'
            ]),
        },
        created() {
            const member = this.getMemberById(this.$route.params.memberId);
            if(member){
                this.formPass = member;
            }else{
                this.loadMemerDetail();
            }
        },
        mounted() {}
    }
</script>

<style scoped>
    input[type="file"] {
        display: none;
    }
    .bg-rad{
        padding: 17px;border: 1px solid #f1f1f1;border-radius: 15px;
    }
    .custom-file-upload {
        border: 1px solid #ccc;
        display: inline-block;
        padding: 6px 12px;
        cursor: pointer;
    }
    .bg-rad{
        padding: 17px;border: 1px solid #f1f1f1;border-radius: 15px;
    }
    .p-img{
        width: 150px;
    }
</style>